import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=6a26a98a&scoped=true"
import script from "./NewsDetail.vue?vue&type=script&lang=ts"
export * from "./NewsDetail.vue?vue&type=script&lang=ts"
import style0 from "./NewsDetail.vue?vue&type=style&index=0&id=6a26a98a&prod&lang=scss&scoped=true"
import style1 from "./NewsDetail.vue?vue&type=style&index=1&id=6a26a98a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a26a98a",
  null
  
)

export default component.exports